export default __webpack_public_path__ + "static/media/PPAeng.71570a13.pdf";